import { arrayToObject } from '../../utilities'

const handleLoaded = (state, action) => {
  const { comments, taskID } = action

  const asObject = Array.isArray(comments) ? arrayToObject(comments) : {}

  return {
    ...state,
    comments: {
      ...state.comments,
      [taskID]: asObject
    },
    counts: {
      ...state.counts,
      [taskID]: Object.values(asObject).length
    }
  }
}

const handleAdd = (state, action) => {
  const { comment, taskID } = action
  const { id } = comment

  const comments = {
    ...(state.comments[taskID] ?? {}),
    [id]: comment
  }
  if (id !== 'TEMP') {
    delete comments.TEMP
  }

  return {
    ...state,
    comments: {
      ...state.comments,
      [taskID]: comments
    },
    counts: {
      ...state.counts,
      [taskID]: Object.keys(comments).length
    }
  }
}

const handleSetInitialCounts = (state, action) => {
  const { tasks } = action

  if (!tasks.length) {
    return state
  }

  const counts = { ...state.counts }
  tasks.forEach(task => {
    counts[task.id] = task.comments
  })

  return { ...state, counts }
}

const handleDeleteComment = (state, action) => {
  const { taskID, commentID, onCountChange } = action

  const counts = { ...state.counts }
  const comments = { ...state.comments }

  if (taskID in comments) {
    if (commentID in comments[taskID]) {
      const newComments = { ...comments[taskID] }
      delete newComments[commentID]

      comments[taskID] = newComments
      const count = Object.keys(newComments).length
      counts[taskID] = count
      onCountChange(count)
    }
  }

  return { ...state, counts, comments }
}

const handleUpdateComment = (state, action) => {
  const { taskID, commentID, content } = action

  const comments = { ...state.comments }

  if (taskID in comments) {
    if (commentID in comments[taskID]) {
      const newComments = { ...comments[taskID] }
      newComments[commentID] = {
        ...newComments[commentID],
        content
      }
      comments[taskID] = newComments
    }
  }

  return { ...state, comments }
}

export const initialState = {
  comments: {},
  counts: {}
}

export const Actions = {
  LOADED: 'LOADED',
  ADD: 'ADD',
  SET_INITIAL_COUNTS: 'SET_INITIAL_COUNTS',
  DELETE_COMMENT: 'DELETE_COMMENT',
  UPDATE_COMMENT: 'UPDATE_COMMENT'
}

const Handlers = {
  [Actions.LOADED]: handleLoaded,
  [Actions.ADD]: handleAdd,
  [Actions.SET_INITIAL_COUNTS]: handleSetInitialCounts,
  [Actions.DELETE_COMMENT]: handleDeleteComment,
  [Actions.UPDATE_COMMENT]: handleUpdateComment
}

export const taskCommentsReducer = (state, action) => {
  const { type } = action

  if (type in Handlers) {
    return Handlers[type](state, action)
  }

  throw new Error(`Unknown TaskComments reducer type: ${type}`)
}
